import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { DealStatus as r, DealCardAction as m } from "../../../../types/Deal/index.js";
import { StampType as F } from "../../../../components/CouponStamp/index.js";
import { Container as R, HeaderContentContainer as v, CardClick as M, ContainerGrid as N, ImageWrapper as O, Image as B, Content as G, Info as K, TopContent as P, TimestampArea as V, TimestampIcon as j, PublishDate as w, Title as z, Body as H, Stamp as W, BottomUserActionsContent as X, FooterContentContainer as q, CashbackContentContainer as J } from "./style.js";
import { DealStoreLabel as Q } from "../../DealStoreLabel/index.js";
import { Clock as U } from "@pelando/fontawesome/icons";
import { useTranslation as Y } from "../../../../hooks/useTranslation/index.js";
import { CashbackTag as Z } from "../../../../components/CashbackTag/index.js";
import { CashbackFooter as $ } from "../DealCard/style.js";
import { ReactComponent as ee } from "../../../../resources/graphics/cashback/cashback-icon.svg.js";
const ae = "default-feed-timestamp-title", re = (t) => ({
  [r.ACTIVE]: "",
  [r.DELETED]: "label-by-status-deleted",
  [r.EXPIRED]: "label-by-status-expired",
  [r.MODERATED]: "label-by-status-moderated",
  [r.PENDING]: "label-by-status-pending"
})[t], Ce = ({
  id: t,
  innerRef: T,
  className: y,
  title: l,
  value: u,
  status: p = r.ACTIVE,
  image: D,
  storeName: d,
  storeImage: f,
  storeLink: C = "",
  timestamp: k,
  timestampTitle: I = ae,
  stampType: g = F.PRICE,
  topUserActionsContent: b,
  bottomUserActionsContent: h,
  headerContent: E,
  footerContent: i,
  storeSlug: A,
  dealUrl: L,
  cashbackPercentage: c = 0,
  dispatch: o,
  ..._
}) => {
  const { t: n } = Y("common"), s = p !== r.ACTIVE, S = C && d, x = s ? 0 : c;
  return /* @__PURE__ */ a(R, { ref: T, className: y, ..._, children: [
    E && /* @__PURE__ */ a(v, { children: [
      " ",
      E,
      " "
    ] }),
    /* @__PURE__ */ e(
      M,
      {
        onClick: () => o({
          payload: { id: t },
          type: m.ON_CARD_CLICK
        })
      }
    ),
    /* @__PURE__ */ a(N, { children: [
      /* @__PURE__ */ e(
        Z,
        {
          type: "supercashback",
          style: { position: "absolute", top: 16, zIndex: 3 },
          percentage: c
        }
      ),
      /* @__PURE__ */ e(
        O,
        {
          onClick: () => o({
            payload: { id: t },
            type: m.ON_IMAGE_CLICK
          }),
          children: /* @__PURE__ */ e(
            B,
            {
              alt: l,
              src: D || "",
              isInactive: s,
              errorImage: f,
              inactiveLabel: n(re(p))
            }
          )
        }
      ),
      /* @__PURE__ */ a(G, { "aria-disabled": s, children: [
        /* @__PURE__ */ a(K, { children: [
          b && /* @__PURE__ */ e(P, { children: b }),
          /* @__PURE__ */ a(V, { title: n(I), children: [
            /* @__PURE__ */ e(j, { icon: U, "aria-label": n(I) }),
            /* @__PURE__ */ e(w, { children: k })
          ] })
        ] }),
        /* @__PURE__ */ e(
          z,
          {
            onClick: () => o({
              payload: { id: t },
              type: m.ON_TITLE_CLICK
            }),
            title: l,
            url: L,
            children: l
          }
        ),
        /* @__PURE__ */ a(H, { children: [
          /* @__PURE__ */ e(W, { value: u, type: g }),
          S && /* @__PURE__ */ e(
            Q,
            {
              name: d,
              link: C,
              slug: A,
              dispatch: o
            }
          )
        ] })
      ] }),
      h && /* @__PURE__ */ e(X, { children: h })
    ] }),
    i && /* @__PURE__ */ a(q, { children: [
      " ",
      i,
      " "
    ] }),
    /* @__PURE__ */ e(
      J,
      {
        "data-is-visible": x && !i,
        children: /* @__PURE__ */ a($, { children: [
          /* @__PURE__ */ e(ee, {}),
          c,
          "% ",
          n("super-cashback-percentage-tag-text")
        ] })
      }
    )
  ] });
};
export {
  ae as DEFAULT_FEED_TIMESTAMP_TITLE,
  Ce as FeedCard
};
